/**
 * 야경 시즌 연출의 스위치(사용자 지시 2026-10-21 「할로윈 · 크리스마스 기간에 맞게 야경 이펙트」 · 「로그인 설정 탭에서 시즌을 체크」).
 *
 * <p>three 를 싣지 않는 작은 모듈이다 — 로그인 첫 묶음({@code LoginBackdrop})이 읽어도 연출 코드가 딸려 오지 않게. 값은
 * {@code LoginBackdrop} 이 설정에서 적고, {@code lightShow} 가 바퀴를 새로 열 때마다 읽는다(장면 prop 으로 내리지 않는 것은
 * 그 길의 파일들을 앱 로그인 작업이 쥐고 있어서다 — 2026-10-21).
 */
export type LightSeason = 'halloween' | 'christmas';

export const LIGHT_SEASONS: readonly { key: LightSeason; label: string }[] = [
  { key: 'halloween', label: '할로윈' },
  { key: 'christmas', label: '크리스마스' },
];

/**
 * 지금 잡고 있는 쪽들 — 마지막에 잡은 쪽의 시즌이 선다. 설정 화면은 미리보기와 전체 화면이 같이 서므로, 한쪽이 내려갈 때
 * 통째로 비우면 남은 쪽의 시즌까지 사라진다.
 */
const holders: { season: LightSeason | null }[] = [];

/** 시즌을 잡는다. 돌려준 함수로 놓는다. */
export function holdLightSeason(season: LightSeason | null | undefined): () => void {
  const h = { season: season === 'halloween' || season === 'christmas' ? season : null };
  holders.push(h);
  return () => {
    const i = holders.indexOf(h);
    if (i >= 0) holders.splice(i, 1);
  };
}

export function lightSeason(): LightSeason | null {
  return holders[holders.length - 1]?.season ?? null;
}
